export default __webpack_public_path__ + "static/media/p1.78fe243a.png";